import CloseButton from "src/components/button/close-button";
import Text from "src/components/text/text";
import TextToSpeech from "src/components/text/text-speech";
import { Fragment, useEffect, useState, useRef } from "react";
import { useNavigationStore } from "src/store/navigationStore";
import { ShareButton } from "../../button/share-button";
import useMdBreakpoint from "../../../hooks/useMdBreakpoint";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "../../../store/appStore";
import { useTranslation } from "react-i18next";
import HtmlText from "../../text/html-text";
import { CHAT_TYPE } from "@/types/navigation-mode";
import ChatText from "../../text/chat-text";
// import useMessagePlayer from "@/hooks/useMessagePlayer";
import { useAudioStore } from "@/store/audioStore";

export default function NavHeader({ referrer }: { referrer?: string }) {
  const currentLevel = useNavigationStore((state) => state.currentLevel);
  const navigationMessage = useNavigationStore(
    (state) => state.navigationMessage,
  );
  const chatAnswer = useNavigationStore((state) => state.chatAnswer);

  // const startAutoPlayDelay = useNavigationStore(
  //   (state) => state.startAutoPlayDelay
  // );
  const stopAutoPlay = useNavigationStore((state) => state.stopAutoPlay);
  const navData = useNavigationStore((state) => state.navData);

  const [showAnswer, setShowAnswer] = useState(true);
  const [showNavMessage, setShowNavMessage] = useState(false);

  const micInstruction = useAppStore((state) => state.micInstruction);
  const showNavError = useAppStore((state) => state.showNavError);
  const isVoiceChatMode = useAppStore((state) => state.isVoiceChatMode);
  // const setConversationId = useNavigationStore(
  //   (state) => state.setConversationId
  // );
  const resetNavigationSessionData = useNavigationStore(
    (state) => state.resetNavigationSessionData,
  );
  const setCurrentMode = useNavigationStore((state) => state.setCurrentMode);
  const navMode = useNavigationStore((state) => state.navMode);
  const setInterrupt = useNavigationStore((state) => state.setInterrupt);
  const isInterrupt = useNavigationStore((state) => state.isInterrupt);
  const isLoading = useNavigationStore((state) => state.isLoading);
  const isChatOpen = useAppStore((state) => state.isChatOpen);
  const setChatType = useAppStore((state) => state.setChatType);
  const chatOpenRef = useRef(isChatOpen);
  const latestMessage = useRef("");
  // const { cancelReading } = useMessagePlayer();
  const setStop = useAudioStore((s) => s.setStop);
  const chatAnswerShown = useRef(false);
  const isMd = useMdBreakpoint();
  let navigate = useNavigate();
  let { t } = useTranslation();

  const [_isDisplayUI, _setIsDisplayUI] = useState<boolean>(false);
  const setIsDisplayUI = useNavigationStore((state) => state.setIsDisplayUI);
  const isDisplayUI = useNavigationStore((state) => state.isDisplayUI);
  useEffect(() => {
    _setIsDisplayUI(isDisplayUI);
  }, [isDisplayUI]);

  // useEffect(() => {
  //   console.log("navigationMessage=", navigationMessage);
  //   latestMessage.current = navigationMessage;
  //   if (navigationMessage !== "") {
  //     // stopAutoPlay();
  //     cancelReading();
  //     setShowAnswer(false);
  //     setShowNavMessage(true);
  //   } else if (navigationMessage === "") {
  //     setShowNavMessage(false);
  //   }
  // }, [navigationMessage]);

  // useEffect(() => {
  //   console.log("chatAnswer#1 latestMessage.current", latestMessage.current)
  //   if (chatAnswer && !showNavMessage) {
  //     setShowAnswer(true);
  //   } else {
  //     setShowAnswer(false);
  //     console.log("empty chatAnswer: navData=", navData);
  //   }
  // }, [chatAnswer, navigationMessage]);

  useEffect(() => {
    chatAnswerShown.current = false;
    if (chatAnswer) {
      setShowAnswer(true);
      setShowNavMessage(false);
    }
  }, [chatAnswer]);

  useEffect(() => {
    if (navigationMessage !== "") {
      chatAnswerShown.current = true;
      // setStop();
      setShowAnswer(false);
      setShowNavMessage(true);
    } else {
      setShowNavMessage(false);
      if (!chatAnswerShown.current && chatAnswer) {
        setShowAnswer(true);
      }
    }
  }, [navigationMessage]);

  useEffect(() => {
    chatOpenRef.current = isChatOpen;
  }, [isChatOpen]);

  const hideMessage = () => {
    console.log("hideMessage: ", chatOpenRef.current);
    if (!chatOpenRef.current) {
      // startAutoPlayDelay(0);
    }
  };

  const startAutoPlay = () => {
    console.log("startAutoPlay: ", chatOpenRef.current);
    setShowAnswer(false);
    setShowNavMessage(true);
    if (!chatOpenRef.current) {
      //don't use delay(2000) here
      // setTimeout(() => {
      //   startAutoPlayDelay(0);
      // }, 2000);
    }
  };

  const showMobileChatbotQuestion = () => {
    return (
      <div className="p-[20px] md:block">
        <ChatText
          fromChatBot={true}
          text={t("chatbot_default")}
          useTypeWriter={true}
        />
      </div>
    );
  };

  const showNavigationAnswer = () => {
    const activeText =
      !isLoading && showNavMessage && navigationMessage !== ""
        ? navigationMessage
        : !isLoading && showAnswer
          ? chatAnswer
          : "";

    const isNavText = activeText === navigationMessage && activeText !== "";
    const isChatAnswerText = activeText === chatAnswer && activeText !== "";

    return (
      <>
        {activeText ? (
          <div className="p-[20px] md:block">
            <TextToSpeech
              text={activeText}
              onFinish={() => {
                if (isNavText) {
                  console.log("text-to-speech#2 onFinish");
                  hideMessage();
                } else {
                  console.log("text-to-speech#1 onFinish");
                  startAutoPlay();
                }
              }}
              withAnimation={isChatAnswerText && !isLoading && !isInterrupt}
              showText={isChatAnswerText ? showAnswer && chatAnswer !== "" : true}
            />
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  const showMessages = () => {
    return (
      <>
        {isChatOpen && !isMd
          ? showMobileChatbotQuestion()
          : showNavigationAnswer()}
      </>
    );
  };

  const showMicPermission = () => {
    const text = `${t("chat_grant_mic_permission")}\n${t(micInstruction)}`;
    return (
      <div className="p-[20px] md:block">
        <HtmlText text={text} tag="b" />
        <TextToSpeech text={text} showText={false} />
      </div>
    );
  };

  const resetChat = () => {
    console.log("reset chat, stop audio");
    // cancelReading();
    // setStop();
    // setConversationId(""); // reset chatbot conversation
    setCurrentMode(navMode); // reset navigation mode to preferred mode in settings
    stopAutoPlay();
    setInterrupt(true);
    setChatType(CHAT_TYPE.NAVIGATION);
    resetNavigationSessionData();
    navigate("/");
  };

  return (
    <>
      <div className={_isDisplayUI ? '' : 'opacity-[0] pointer-events-none'}>
        <div className="flex w-full justify-end items-center px-[20px] pt-[20px]">
          <Text
            text={currentLevel}
            className="bg-glass floor-indicator flex items-center justify-center text-500"
          />
          <div className="flex w-full justify-end z-50 gap-4">
            <div>
              <ShareButton />
            </div>
            {referrer?.startsWith("whatsapp") ? null : (
              <CloseButton
                goBack={false}
                onClick={() => resetChat()}
                withGlassBg={true}
              />
            )}
          </div>
        </div>
      </div>
      {showNavError && isVoiceChatMode ? showMicPermission() : showMessages()}
    </>
  );
}
